import React from 'react';

import { useTranslation } from 'react-i18next';

interface LogoProps {
  className?: string;
}

const PostureXeLogo: React.FC<LogoProps> = ({ className = "" }) => {
  const { t } = useTranslation();
  return (
    <div className={`min-w-0 flex-1 ${className}`}>
      <div className="text-regina-red text-lg font-extrabold leading-tight tracking-tight">
        PostureXe
      </div>
      <div className="mt-1 max-w-[11rem] text-regina-gray-800 text-sm font-semibold leading-snug">
        {t('logo.tagline')}
      </div>
    </div>
  );
};

export default PostureXeLogo;
